import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';
import { CheckCircle2, Clock } from 'lucide-react';

const StepStart = ({ listing, onNext }) => (
  <div className="space-y-6">
    <div>
      <h1 className="text-2xl sm:text-3xl font-heading font-extrabold text-slate-900 leading-tight">
        Let's list your place.
      </h1>
      <p className="mt-2 text-base text-slate-600 leading-relaxed">
        Takes about 10 minutes. You can save and come back anytime — nothing goes live
        until our team reviews it.
      </p>
    </div>

    <Card className="bg-amber-50 border-amber-200/60">
      <CardContent className="p-5 space-y-3">
        <p className="text-sm font-semibold text-amber-900">What we'll ask for:</p>
        <ul className="space-y-2 text-sm text-slate-700">
          <li className="flex gap-2"><CheckCircle2 className="h-4 w-4 text-amber-700 flex-shrink-0 mt-0.5" /> The type of place and how it's set up</li>
          <li className="flex gap-2"><CheckCircle2 className="h-4 w-4 text-amber-700 flex-shrink-0 mt-0.5" /> Address (kept private until a lease is signed)</li>
          <li className="flex gap-2"><CheckCircle2 className="h-4 w-4 text-amber-700 flex-shrink-0 mt-0.5" /> At least 4 photos — including one of the exterior</li>
          <li className="flex gap-2"><CheckCircle2 className="h-4 w-4 text-amber-700 flex-shrink-0 mt-0.5" /> All-in pricing — rent plus every extra cost</li>
          <li className="flex gap-2"><CheckCircle2 className="h-4 w-4 text-amber-700 flex-shrink-0 mt-0.5" /> Lease terms, amenities, and house rules</li>
        </ul>
      </CardContent>
    </Card>

    <Card className="bg-white border-slate-200">
      <CardContent className="p-5 flex gap-3">
        <Clock className="h-5 w-5 text-slate-500 flex-shrink-0 mt-0.5" />
        <div>
          <p className="text-sm font-semibold text-slate-900">Review takes up to 24 hours.</p>
          <p className="text-xs text-slate-600 mt-1 leading-relaxed">
            Our team checks every listing for accuracy, clarity, and fair pricing
            before it goes live. You'll get an email with the decision.
          </p>
        </div>
      </CardContent>
    </Card>

    <Button
      className="w-full btn-primary h-12 text-base"
      onClick={onNext}
      data-testid="step-start-continue"
    >
      Start
    </Button>
  </div>
);

export default StepStart;
